import moment from "moment";

const state = {
    auth:false,
};

const getters = {
    can: state => (action, group) => {
        if (!state.auth || !state.auth.user) {
            return false;
        }

        let actions = [action];

        if (action === 'read' || action === 'write') {
            actions.push('admin');
        }

        let hasAccess = false;

        actions.forEach(action => {
            let permission = action + ' ' + group;
            if (state.auth.user.permissions.indexOf(permission) !== -1) {
                hasAccess = true;
            }
        });

        return hasAccess;
    },

    getAuth: state => state.auth,
    hasLicense: state => license => {
        if (!state.auth || !state.auth.user) {
            return false;
        }

        return state.auth.user.licenses.indexOf(license) !== -1;
    },
    isAuthenticated: state => state.auth !== false,
    isDemoMode: state => {
        if (!state.auth || !state.auth.settings) {
            return false;
        }

        return state.auth.settings.archibase.settings.demo_mode;
    },
    moduleIsActive: (state) => (module) => {
        return state.auth !== false &&
            state.auth.modules.indexOf(module) !== -1;
    },

    isAdmin: (state) => {
        if (!state.auth) {
            return false;
        }

        return state.auth.user.isAdmin;
    },
};

const actions = {
    authenticate: (store) => {
        axios.get('/api/v1/me')
            .then((resp) => {
                moment.locale(resp.data.user.currentlocale);
                store.commit('AUTH_SET', resp.data);
            });
        //TODO: Handle failed responses.
    },
    setAuth: (store, payload) => store.commit("AUTH_SET",payload),
};

const mutations = {
    AUTH_SET: (state, payload) => state.auth = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
